var _line, _line2, _circle, _circle2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4.31971e-8,
    y1: 2.80007,
    x2: 18.9412,
    y2: 2.80007,
    stroke: "currentColor",
    strokeWidth: 0.988235
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 4.31971e-8,
    y1: 11.0352,
    x2: 18.9412,
    y2: 11.0352,
    stroke: "currentColor",
    strokeWidth: 0.988235
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.35306,
    cy: 2.88235,
    r: 2.38824,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.988235
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5882,
    cy: 11.1177,
    r: 2.38824,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.988235
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.7d669792.svg";
export { ForwardRef as ReactComponent };